import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";

import { useHistory, useLocation } from "react-router-dom";
import Status from "./Status";
import bigInt from "big-integer";
import { toFixed, tokens } from "../../../constants/constants";
import LogoImg from "./LogoImg";
import { useMemo } from "react";
import PoolCard from "../../poolCard/poolCard";
import { ReactComponent as CheckMarkIconSvg } from "../../../assets/certified.svg";
import { Tooltip } from "@material-ui/core";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: "1.5rem",
    gap: "1.5rem",

    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },

  table: {
    width: "100%",
    marginTop: "1.5rem",
    borderCollapse: "collapse",
    borderSpacing: "0",
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,
    borderRadius: "32px",

    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "table",
    },
  },
  tableHeader: {
    color: "#A0A0A0",
    fontSize: "14px",
    // background: "#393939",
    background: theme?.colors?.pools?.headerBackground,
    borderBottom: "1px solid " + theme?.colors?.pools?.rowBorderBottom,
    padding: "16px",
  },
  tableHeaderItem: {
    width: "15%",
    padding: "16px",
    fontWeight: "normal",
  },
  tableBody: {
    // background: "#242424",
    background: theme?.colors?.pools?.bodyBackground,
    color: "#fff",
    width: "100%",
  },
  tableRow: {
    // borderBottom: "1px solid #393939",
    borderBottom: "1px solid" + theme?.colors?.pools?.rowBorderBottom,
    cursor: "pointer",
    color: theme?.colors?.pools?.tableDataText,
  },
  tableRowLast: {
    cursor: "pointer",
    borderBottom: "none",
    color: theme?.colors?.pools?.tableDataText,
  },
  tableNameRow: {
    display: "flex",
    alignItems: "center",
    color: theme?.colors?.pools?.tableDataText,
    fontWeight: 600,
  },
  tableName: {
    width: "max-content",
    alignItems: "center",
    margin: "0 2px 0 0",
  },
  checkMarkIcon: {
    color: theme?.colors.poolCard?.linkIcon,
    width: "20px",
    height: "20px",
  },
  tableData: {
    padding: "16px",
    color: theme?.colors?.pools?.tableDataText,
  },
  button: {
    padding: "14px 20px",
    fontSize: "16px",
    margin: "10px",
    cursor: "pointer",

    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "solid 2px" + theme?.colors?.wallet?.buttonBorderSecondary,
    color: theme?.colors?.wallet?.buttonTextTertiary,
  },
  disabledButton: {
    padding: "14px 20px",
    fontSize: "16px",
    margin: "10px",
    cursor: "initial",
    opacity: "0.4",

    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "solid 2px" + theme?.colors?.wallet?.buttonBorderSecondary,
    color: theme?.colors?.wallet?.buttonTextTertiary,
  },
});

const Table = ({ classes, data }) => {
  const history = useHistory();
  const location = useLocation();
  const itemsPerPage = 10;
  const [page, setPage] = useState(1);

  const maxPage = useMemo(() => Math.ceil(data.length / itemsPerPage), [data]);

  useEffect(() => {
    const queryPage =
      Number(new URLSearchParams(location.search).get("page")) <= 0
        ? 1
        : Number(new URLSearchParams(location.search).get("page"));

    if (maxPage >= queryPage) {
      setPage(queryPage);

      const params = new URLSearchParams();
      params.append("page", queryPage);

      history.replace({ search: params.toString() });
    } else {
      setPage(1);

      const params = new URLSearchParams();
      params.append("page", 1);

      history.replace({ search: params.toString() });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxPage, location.search]);

  const handlePrev = () => {
    if (page > 1) {
      setPage(page - 1);

      const params = new URLSearchParams();
      params.append("page", page - 1);

      history.push({ search: params.toString() });
    }
  };

  const handleNext = () => {
    if (page < maxPage) {
      setPage(page + 1);
      const params = new URLSearchParams();
      params.append("page", page + 1);

      history.push({ search: params.toString() });
    }
  };

  const paginatedData = useMemo(
    () => data.slice((page - 1) * itemsPerPage, page * itemsPerPage),
    [page, data]
  );

  return (
    <>
      <table className={classes.table}>
        <thead className={classes.tableHeader}>
          <tr>
            <th
              style={{
                width: "22%",
                padding: "16px",
                borderTopLeftRadius: "32px",
                fontWeight: "normal",
              }}
            >
              Name
            </th>
            <th
              className={classes.tableHeaderItem}
              style={{
                width: "16%",
              }}
            >
              Status
            </th>
            <th className={classes.tableHeaderItem}>Participants</th>
            <th
              className={classes.tableHeaderItem}
              style={{
                width: "11%",
              }}
            >
              Funded
            </th>
            <th className={classes.tableHeaderItem}>Raised</th>
            <th className={classes.tableHeaderItem}>Goal</th>
            <th
              style={{
                width: "15%",
                padding: "16px",
                borderTopRightRadius: "32px",
                fontWeight: "normal",
              }}
            >
              Price
            </th>
          </tr>
        </thead>
        <tbody className={classes.tableBody}>
          {data
            .slice((page - 1) * itemsPerPage, page * itemsPerPage)
            .map((item, index) => (
              <tr
                key={item.saleTitle + item.presaleIndex}
                onClick={() => {
                  history.push(item.url);
                }}
                className={
                  index === paginatedData.length - 1
                    ? classes.tableRowLast
                    : classes.tableRow
                }
              >
                <td
                  style={
                    index === paginatedData.length - 1
                      ? {
                          padding: "16px",
                          borderBottomLeftRadius: "32px",
                        }
                      : { padding: "16px" }
                  }
                >
                  <div className={classes.tableNameRow}>
                    <LogoImg logoImage={item.linkLogo} />
                    <p className={classes.tableName}>{item.saleTitle}</p>
                    {item.certified && (
                      <Tooltip title="Certified BUIDLers">
                        <CheckMarkIconSvg className={classes.checkMarkIcon} />
                      </Tooltip>
                    )}
                  </div>
                </td>
                <td
                  className={classes.tableData}
                  style={{
                    width: "16%",
                  }}
                >
                  <Status poolInfo={item} size="sm" />
                </td>
                <td className={classes.tableData}>
                  {item.totalInvestorsCount ?? "0"}
                </td>
                <td
                  className={classes.tableData}
                  style={{
                    width: "11%",
                  }}
                >
                  {tokens[item?.fundingTokenAddress]?.label}
                </td>
                <td className={classes.tableData}>
                  {toFixed(
                    bigInt(item?.totalCollectedWei || "0"),
                    tokens[item?.fundingTokenAddress]?.decimals ?? 18,
                    3
                  )}
                </td>
                <td className={classes.tableData}>
                  {toFixed(
                    bigInt(item?.hardCapInWei) || "0",
                    tokens[item?.fundingTokenAddress]?.decimals ?? 18,
                    3
                  )}
                </td>
                <td
                  style={
                    index === paginatedData.length - 1
                      ? {
                          padding: "16px",
                          borderBottomRightRadius: "32px",
                          width: "15%",
                        }
                      : { padding: "16px", width: "15%" }
                  }
                >
                  {toFixed(
                    bigInt(item.tokenPriceInWei),
                    tokens[item?.fundingTokenAddress]?.decimals ?? 18,
                    3
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      <div className={classes.root}>
        {data
          .slice((page - 1) * itemsPerPage, page * itemsPerPage)
          .map((item, index) => (
            <PoolCard key={item.saleTitle + item.presaleIndex} pool={item} />
          ))}
      </div>
      <div
        style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}
      >
        <button
          className={page === 1 ? classes.disabledButton : classes.button}
          onClick={handlePrev}
        >{`< ${page * itemsPerPage - itemsPerPage} - ${
          page * itemsPerPage
        }`}</button>
        <button
          className={page === maxPage ? classes.disabledButton : classes.button}
          onClick={handleNext}
        >{`${page * itemsPerPage + 1} - ${
          page * itemsPerPage + itemsPerPage
        } >`}</button>
      </div>
    </>
  );
};

export default withStyles(styles)(Table);
